/**
 * THE CLOCK ON A REFERRAL (REF-11, Peter 2026-08-27: "if there's an
 * expiration, there needs to be a clock that show how much longer").
 *
 * BYTE-MATCHED COPY of image-os-web/src/lib/referral-window.ts (the owner's
 * board reads the same fact) — edit THERE first, then re-copy: two clocks that
 * disagree about the same window is the lockstep failure this note exists to
 * prevent.
 *
 * Pure and client-safe. The window only ticks while the referral is still
 * WORKING TOWARD its conditions — once the bonus is owed (first_rent), paid,
 * expired or denied, a countdown would be noise or a lie. A past date on a
 * still-open row reads "Window closed" until the nightly job renames it
 * expired — the screen must be honest even between cron ticks.
 */
const TICKING = new Set(['submitted', 'contacted', 'toured', 'lease_signed', 'board_approved']);

export interface ReferralWindow {
  label: string;
  /** Two weeks or less — the row should say so louder. */
  urgent: boolean;
}

export function referralWindow(
  expiration: string | null | undefined,
  status: string | null | undefined,
  today: Date = new Date(),
): ReferralWindow | null {
  if (!expiration) return null;
  if (!TICKING.has(status ?? 'submitted')) return null;
  const [y, m, d] = expiration.split('-').map(Number);
  if (!y || !m || !d) return null;
  const end = Date.UTC(y, m - 1, d);
  const now = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
  const days = Math.round((end - now) / 86_400_000);
  if (days < 0) return { label: 'Window closed', urgent: true };
  if (days === 0) return { label: 'Expires today', urgent: true };
  return { label: `${days} day${days === 1 ? '' : 's'} left`, urgent: days <= 14 };
}
